// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__VtssA","icon":"Alert_icon__1OBP5","close":"Alert_close__HaWCv","content":"Alert_content__6aZt6","text":"Alert_text__7vQw7"};